import { Modal, Typography } from 'antd';
import { useTranslation } from 'translations/hooks';

import { useBulkStatusUpdate } from 'business/quality-control/pages/segment-history/components/bulk-status-modal/use-bulk-status-update';
import { Quality_SegmentHistoryStatusEnum_Enum } from 'generated/graphql';

export const BulkStatusConfirmModal = ({
  open,
  onCancel,
  onSuccess,
  newStatus,
  scanSiteId,
  total,
  includedSegmentIds,
}: {
  open: boolean;
  onCancel: () => void;
  onSuccess: () => void;
  newStatus: Quality_SegmentHistoryStatusEnum_Enum;
  scanSiteId: string;
  total: number;
  includedSegmentIds: string[];
}) => {
  const { t } = useTranslation();

  const { submit, isPending } = useBulkStatusUpdate({ onSuccess });

  const handleOk = () => {
    submit({ newStatus, scanSiteId, includedSegmentIds });
  };

  return (
    <Modal
      title={t('qualityControl.segmentHistory.bulkStatusConfirmModal.title')}
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      okButtonProps={{ loading: isPending }}
      destroyOnHidden
    >
      <Typography.Paragraph>
        {t(
          'qualityControl.segmentHistory.bulkStatusConfirmModal.selectedCount',
          { selected: includedSegmentIds.length, total },
        )}
      </Typography.Paragraph>
    </Modal>
  );
};
